import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/konto/oppskrifter/recipes.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/konto/oppskrifter/UI/ClientUI.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.1.7_@babel+core@7.26.7_@opentelemetry+api@1.9.0_react-dom@19.0.0_react@19.0.0__react@19.0.0_sass@1.84.0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.1.7_@babel+core@7.26.7_@opentelemetry+api@1.9.0_react-dom@19.0.0_react@19.0.0__react@19.0.0_sass@1.84.0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
